/* ASTAMR mall signage. No libraries, cookies, analytics or credentials. */
(function () {
  'use strict';
  var activePlayer = null;

  function readConfig(root) {
    var config = JSON.parse(root.getAttribute('data-config'));
    if (!config || !Array.isArray(config.items)) throw new Error('Invalid playlist');
    config.fit = config.fit === 'cover' ? 'cover' : 'contain';
    config.items = config.items.filter(function (item) {
      return item && (item.type === 'image' || item.type === 'video') && typeof item.src === 'string' && item.src.length > 0;
    });
    return config;
  }

  function Player(root) {
    var self = this;
    this.root = root;
    this.stage = root.querySelector('.screen-stage');
    this.config = readConfig(root);
    this.signature = JSON.stringify(this.config);
    this.pending = null;
    this.index = -1;
    this.token = 0;
    this.timer = null;
    this.pollTimer = null;
    this.fetchAbort = null;
    this.watchdog = null;
    this.current = null;
    this.loading = null;
    this.stopped = false;
    this.failures = 0;
    this.lock = null;
    this.editor = root.getAttribute('data-editor') === 'true';
    document.documentElement.classList.toggle('editor', this.editor);
    this.onClick = function () {
      if (self.editor) return;
      var request = root.requestFullscreen || root.webkitRequestFullscreen;
      if (request && !document.fullscreenElement) {
        try { var result = request.call(root); if (result && result.catch) result.catch(function () {}); } catch (_) {}
      }
      if (self.current && self.current.tagName === 'VIDEO') {
        var playback = self.current.play();
        if (playback && playback.catch) playback.catch(function () {});
      }
      self.wake();
    };
    this.onVisibility = function () { if (!document.hidden) { self.wake(); if (!self.editor) self.poll(); } };
    this.onBlock = function (event) {
      var index = self.config.items.findIndex(function (item) { return item.id === event.detail.blockId; });
      if (index >= 0) { self.index = index - 1; self.next(); }
    };
    root.addEventListener('click', this.onClick);
    document.addEventListener('visibilitychange', this.onVisibility);
    if (this.editor) document.addEventListener('shopify:block:select', this.onBlock);
    this.next();
    if (!this.editor) this.pollTimer = setInterval(function () { self.poll(); }, 60000);
    this.wake();
  }

  Player.prototype.releaseMedia = function (node) {
    if (!node) return;
    node.onload = node.onerror = node.onended = node.onplaying = node.ontimeupdate = null;
    if (node.tagName === 'VIDEO') { node.pause(); node.removeAttribute('src'); node.load(); }
    if (node.parentNode) node.parentNode.removeChild(node);
  };

  Player.prototype.next = function () {
    if (this.stopped) return;
    var self = this;
    var token = ++this.token;
    clearTimeout(this.timer);
    clearInterval(this.watchdog);
    this.releaseMedia(this.loading);
    this.loading = null;
    if (this.pending) {
      this.config = this.pending;
      this.pending = null;
      this.index = -1;
      this.failures = 0;
    }
    if (!this.config.items.length) {
      this.releaseMedia(this.current);
      this.current = null;
      return;
    }
    this.index = (this.index + 1) % this.config.items.length;
    var item = this.config.items[this.index];
    var node = document.createElement(item.type === 'video' ? 'video' : 'img');
    this.loading = node;
    node.style.objectFit = this.config.fit;
    var ready = false;
    var finished = false;
    var lastProgress = Date.now();
    var lastTime = -1;

    function fail() {
      if (finished || token !== self.token || self.stopped) return;
      finished = true;
      clearTimeout(self.timer);
      clearInterval(self.watchdog);
      self.failures += 1;
      if (self.loading === node) self.loading = null;
      if (self.current === node) self.current = null;
      self.releaseMedia(node);
      // If every item fails, show the brand slate and retry slowly.
      var exhausted = self.failures >= self.config.items.length;
      if (exhausted) { self.releaseMedia(self.current); self.current = null; }
      self.timer = setTimeout(function () { self.next(); }, exhausted ? 10000 : 1000);
    }

    function show() {
      if (ready || finished || token !== self.token || self.stopped) return;
      ready = true;
      self.failures = 0;
      clearTimeout(self.timer);
      self.releaseMedia(self.current);
      self.current = node;
      self.loading = null;
      node.classList.add('is-active');
      if (item.type === 'image') {
        self.timer = setTimeout(function () { self.next(); }, Math.max(3, Math.min(30, Number(item.seconds) || 7)) * 1000);
      }
    }

    node.onerror = fail;
    this.timer = setTimeout(fail, 25000);
    this.stage.appendChild(node);
    if (item.type === 'image') {
      node.alt = 'ASTAMR';
      node.onload = show;
      node.src = item.src;
    } else {
      node.muted = true;
      node.defaultMuted = true;
      node.autoplay = true;
      node.playsInline = true;
      node.controls = false;
      node.preload = 'auto';
      node.setAttribute('muted', '');
      node.setAttribute('playsinline', '');
      node.onplaying = function () { lastProgress = Date.now(); show(); };
      node.ontimeupdate = function () {
        if (node.currentTime > lastTime) { lastTime = node.currentTime; lastProgress = Date.now(); }
      };
      node.onended = function () { if (!finished && token === self.token) self.next(); };
      this.watchdog = setInterval(function () { if (Date.now() - lastProgress > 25000) fail(); }, 5000);
      node.src = item.src;
      var playback = node.play();
      if (playback && playback.catch) playback.catch(fail);
    }
  };

  Player.prototype.poll = function () {
    if (this.stopped || this.fetchAbort || !window.fetch || !window.AbortController) return;
    var self = this;
    var controller = new AbortController();
    this.fetchAbort = controller;
    var timeout = setTimeout(function () { controller.abort(); }, 15000);
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', this.root.getAttribute('data-section-id'));
    url.searchParams.set('_screen_refresh', String(Date.now()));
    fetch(url.toString(), { cache: 'no-store', credentials: 'same-origin', signal: controller.signal })
      .then(function (response) { if (!response.ok) throw new Error('Unavailable'); return response.text(); })
      .then(function (html) {
        if (self.stopped) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var root = doc.querySelector('[data-astamr-screen]');
        if (!root) return;
        var config = readConfig(root);
        var signature = JSON.stringify(config);
        if (signature !== self.signature) {
          self.signature = signature;
          self.pending = config;
          // Commit between slides; do not interrupt a playing video.
          if (!self.current && !self.loading) self.next();
        }
      })
      .catch(function () { /* Retain the last valid playlist on network errors. */ })
      .then(function () { clearTimeout(timeout); self.fetchAbort = null; });
  };

  Player.prototype.wake = function () {
    var self = this;
    if (this.editor || this.stopped || this.lock || document.hidden || !navigator.wakeLock) return;
    navigator.wakeLock.request('screen').then(function (lock) {
      if (self.stopped) { lock.release(); return; }
      self.lock = lock;
      lock.addEventListener('release', function () { self.lock = null; });
    }).catch(function () {});
  };

  Player.prototype.destroy = function () {
    this.stopped = true;
    ++this.token;
    clearTimeout(this.timer);
    clearInterval(this.watchdog);
    clearInterval(this.pollTimer);
    if (this.fetchAbort) this.fetchAbort.abort();
    this.releaseMedia(this.loading);
    this.releaseMedia(this.current);
    if (this.lock) this.lock.release();
    this.root.removeEventListener('click', this.onClick);
    document.removeEventListener('visibilitychange', this.onVisibility);
    document.removeEventListener('shopify:block:select', this.onBlock);
  };

  function init() {
    var root = document.querySelector('[data-astamr-screen]');
    if (activePlayer) activePlayer.destroy();
    activePlayer = root ? new Player(root) : null;
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    if (activePlayer && event.target.contains(activePlayer.root)) { activePlayer.destroy(); activePlayer = null; }
  });
  init();
})();
